import React, { useEffect, useRef, useState } from "react";

const TruncateFade = ({ text, className = "" }) => {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const checkTruncation = () => {
            setIsTruncated(el.scrollWidth > el.clientWidth + 1);
        };

        checkTruncation();

        const observer = new ResizeObserver(checkTruncation);
        observer.observe(el);
        return () => observer.disconnect();
    }, [text]);

    return (
        <span
            ref={ref}
            className={`name-fade ${isTruncated ? "truncated" : ""} ${className}`.trim()}
        >
            {text}
        </span>
    );
};

export default TruncateFade;
